// extracted by mini-css-extract-plugin
module.exports = {"vslContainer":"VSL_vslContainer__Sjs0k","videoContainer":"VSL_videoContainer__8GNHj","responsiveIframe":"VSL_responsiveIframe__Mz_M_"};